import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import Section from 'modules/contracts/components/ContractDetails/Section'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'
import type Employee from 'modules/employees/store/models/Employee'

import France from './France'
import Germany from './Germany'
import Italy from './Italy'
import Spain from './Spain'

interface Props {
  contractVersion: ContractVersion
  employee: Employee
  isItalianLegalEntity: boolean
}

const LegalAndLabour = ({ contractVersion, employee, isItalianLegalEntity }: Props) => {
  if (
    !contractVersion.isSpanish &&
    !contractVersion.isFrench &&
    !isItalianLegalEntity &&
    !contractVersion.isGerman
  )
    return <></>

  return (
    <Section icon="academic-cap" title={i18n.t('contract_versions.legal_and_labour.title')}>
      {contractVersion.isSpanish && <Spain contractVersion={contractVersion} employee={employee} />}
      {contractVersion.isFrench && <France contractVersion={contractVersion} employee={employee} />}
      {isItalianLegalEntity && <Italy contractVersion={contractVersion} employee={employee} />}
      {contractVersion.isGerman && (
        <Germany contractVersion={contractVersion} employee={employee} />
      )}
    </Section>
  )
}

export default observer(LegalAndLabour)
